import gql from 'graphql-tag';

export default gql`
  mutation SendShipmentToMama(
    $shipment_id: ID!
  ) {
    sendShipmentToMama(
      shipment_id: $shipment_id
    ) {
      succeed
    }
  }
`;